"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filters through an object and keeps only the keys in `keysToKeep`
 * @param object The object to filter through
 * @param keysToKeep The keys to keep
 */
exports.keepKeys = (object, keysToKeep) => Object.keys(object)
    .filter(key => keysToKeep.includes(key))
    .reduce((result, key) => ({
    ...result,
    [key]: object[key],
}), {});
/**
 * Filters through an object and removes the keys in `keysToRemove`
 * @param object The object to filter through
 * @param keysToRemove The keys to remove
 */
exports.removeKeys = (object, keysToRemove) => Object.keys(object)
    .filter(key => !keysToRemove.includes(key))
    .reduce((result, key) => ({
    ...result,
    [key]: object[key],
}), {});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWwvb2JqZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0E7Ozs7R0FJRztBQUNVLFFBQUEsUUFBUSxHQUFHLENBQ3BCLE1BQVcsRUFDWCxVQUFpQyxFQUNuQyxFQUFFLENBQ0MsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7S0FDZixNQUFNLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFFLEdBQTZCLENBQUMsQ0FBQztLQUNsRSxNQUFNLENBQ0gsQ0FBQyxNQUFNLEVBQUUsR0FBRyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2QsR0FBRyxNQUFNO0lBQ1QsQ0FBQyxHQUFHLENBQUMsRUFBSSxNQUErQyxDQUFDLEdBQUcsQ0FBQztDQUNoRSxDQUFDLEVBQ0YsRUFBRSxDQUNvQyxDQUFBO0FBRWxEOzs7O0dBSUc7QUFDVSxRQUFBLFVBQVUsR0FBRyxDQUN0QixNQUFXLEVBQ1gsWUFBcUMsRUFDdkMsRUFBRSxDQUNDLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0tBQ2YsTUFBTSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsQ0FBQyxZQUFZLENBQUMsUUFBUSxDQUFFLEdBQStCLENBQUMsQ0FBQztLQUN2RSxNQUFNLENBQ0gsQ0FBQyxNQUFNLEVBQUUsR0FBRyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2QsR0FBRyxNQUFNO0lBQ1QsQ0FBQyxHQUFHLENBQUMsRUFBSSxNQUErQyxDQUFDLEdBQUcsQ0FBQztDQUNoRSxDQUFDLEVBQ0YsRUFBRSxDQUN3QyxDQUFBIn0=